import { render, staticRenderFns } from "./MultipleSelectTable.vue?vue&type=template&id=0b7b2b01&"
import script from "./MultipleSelectTable.vue?vue&type=script&lang=js&"
export * from "./MultipleSelectTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports